export const SECURITY_LOADING = 'SECURITY_LOADING';
export const SECURITY_GET_USERDATA_BY_ID = 'SECURITY_GET_USERDATA_BY_ID';
export const SECURITY_GET_USERCREATE_BY_ID = 'SECURITY_GET_USERCREATE_BY_ID';
export const SECURITY_GET_USERMODIFY_BY_ID = 'SECURITY_GET_USERMODIFY_BY_ID';
